// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"27063c74","239":"cf76c795","455":"dc43758e"}[chunkId] + ".chunk.js";
};